import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/carrier/dashboard",
		component: lazy(() => import("./CarriersDashboardPage")),
	},
]);
